import template from "./quote-language-selector.html";

const QuoteLanguageSelectorComponent = {
  bindings: {
    defaultValue: "<",
    onChange: "&",
  },
  template: template,
  controller: class QuoteLanguageController {
    /* @ngInject */
    constructor($scope, quoteLanguages) {
      this.$scope = $scope;
      this.quoteLanguages = quoteLanguages;
    }

    $onInit() {
      this.quoteLanguage = this.defaultValue;
      this.$scope.$watch(
        () => this.quoteLanguage,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal))
            this.onChange({
              oldQuoteLanguage: oldVal,
              newQuoteLanguage: this.quoteLanguage,
            });
        },
      );
    }

    $onChanges(changesObj) {
      if (changesObj.defaultValue && !changesObj.defaultValue.isFirstChange()) this.quoteLanguage = this.defaultValue;
    }
  },
};

export default QuoteLanguageSelectorComponent;
